module.exports = __webpack_public_path__ + "img/evolution.3eba319e.svg";